var damageOrAccidentObj = {
  type: "object",
  title: "Damage / Accident Details",
  required: ["incidentAddress", "incidentDriverDrugTest", "incidentCover", "incidentVehicleStatus", "incidentAssistLine"],
  properties: {
    incidentAddress: {
      title: "Incident Address",
      type: "string"
    },
    incidentDriverDrugTest: {
      title: "Was the driver tested for alcohol or drug abuse? (where applicable)",
      type: "string",
      enum: ["Yes", "No"]
    },
    incidentCover: {
      title: "Is the incident covered under any other policy of insurance?",
      type: "string",
      enum: ["Yes", "No"]
    },
    incidentVehicleStatus: {
      title: "Vehicle Driveable",
      type: "string",
      enum: ["Yes", "No"]
    },
    incidentAssistLine: {
      title: "Was assist line called?",
      type: "string",
      enum: ["Yes", "No"]
    }
  },
  dependencies: {
    incidentAssistLine: {
      oneOf: [{
        properties: {
          incidentAssistLine: {
            enum: ["Yes"]
          },
          incidentRef: {
            title: "Assist line reference number",
            type: "string"
          }
        }
      }, {
        properties: {
          incidentAssistLine: {
            enum: ["No"]
          },
          incidentTowingOperator: {
            title: "Provide details of towing operator used.",
            type: "string"
          }
        }
      }]
    },
    incidentDriverDrugTest: {
      oneOf: [{
        properties: {
          incidentDriverDrugTest: {
            enum: ["Yes"]
          },
          incidentReport: {
            title: "If  the driver was tested for alcohol/drug abuse attach the report",
            type: "array",
            items: {
              type: "object",
              properties: {
                attachment: {
                  type: "array",
                  title: "Attachment",
                  items: [{
                    key: "attachName",
                    title: "Title",
                    type: "string",
                    maxLength: 200
                  }, {
                    key: "attachmentContent",
                    type: "array",
                    title: "Attachment",
                    items: {
                      type: "string",
                      format: "data-url"
                    }
                  }]
                }
              }
            }
          }
        }
      }, {
        properties: {
          incidentDriverDrugTest: {
            enum: ["No"]
          }
        }
      }]
    },
    incidentCover: {
      oneOf: [{
        properties: {
          incidentCover: {
            enum: ["Yes"]
          },
          incidentPolicyDetails: {
            type: "string",
            title: "Details of other policy"
          }
        }
      }, {
        properties: {
          incidentCover: {
            enum: ["No"]
          }
        }
      }]
    }
  }
};

export var schema = {
  title: "Motor Vehicle Loss or Damage",
  description: "Motor Vehicle Loss or Damage Claim Form",
  type: "object",
  properties: {
    insured: {
      type: "object",
      title: "Insured",
      required: ["insuredName", "insuredPolicyNumber", "contactPerson", "brokeremail"],
      properties: {
        insuredName: {
          type: "string",
          title: "Name of Insured"
        },
        insuredPolicyNumber: {
          type: "string",
          title: "Policy Number"
        },
        contactPerson: {
          type: "string",
          title: "Contact Person"
        },
        contactNumber: {
          type: "string",
          title: "Contact Number",
          minLength: 10
        },
        contactEmail: {
          type: "string",
          title: "Contact Email Address",
          format: "email"
        },
        vatNumber: {
          type: "string",
          title: "VAT Number"
        },
        brokeremail: {
          type: "string",
          title: "Broker Email",
          format: "email"
        }
      }
    },
    incident: {
      type: "object",
      title: "Incident",
      required: ["incidentType", "incidentdate"],
      properties: {
        incidentType: {
          title: "Incident Type",
          type: "string",
          enum: ["Vehicle Stolen", "Vehicle stolen and recovered with damages", "Accident (Own Damage)", "Accident with third party"]
        },
        incidentdate: {
          title: "Date of Incident",
          type: "string",
          format: "date-time"
        }
      },
      dependencies: {
        incidentType: {
          oneOf: [{
            properties: {
              incidentType: {
                enum: ["Vehicle Stolen"]
              },
              incidentplace: {
                type: "string",
                title: "Place of Loss"
              }
            }
          }, {
            properties: {
              incidentType: {
                enum: ["Vehicle stolen and recovered with damages"]
              },
              damageOrAccident: damageOrAccidentObj
            }
          }, {
            properties: {
              incidentType: {
                enum: ["Accident (Own Damage)"]
              },
              damageOrAccident: damageOrAccidentObj
            }
          }, {
            properties: {
              incidentType: {
                enum: ["Accident with third party"]
              },
              damageOrAccident: damageOrAccidentObj
            }
          }]
        }
      }
    },
    police: {
      type: "object",
      title: "Police",
      required: ["policeReported"],
      properties: {
        policeReported: {
          type: "string",
          title: "Was the incident reported to the police?",
          enum: ["Yes", "No"]
        }
      },
      dependencies: {
        policeReported: {
          oneOf: [{
            properties: {
              policeReported: {
                enum: ["Yes"]
              },
              reportDetails: {
                type: "object",
                title: "Police Report Details",
                required: ["policePlaceReported", "policeDateReported", "policeCaseNumber"],
                properties: {
                  policePlaceReported: {
                    title: "Place where Reported",
                    type: "string"
                  },
                  policeDateReported: {
                    title: "Date of Reporting",
                    type: "string",
                    format: "date"
                  },
                  policeCaseNumber: {
                    title: "Case Number",
                    type: "string"
                  }
                }
              }
            }
          }]
        }
      }
    },
    vehicleDetails: {
      type: "object",
      title: "Vehicle Details",
      required: ["vehicleMake", "vehicleModel", "vehicleRegistration"],
      properties: {
        vehicleMake: {
          type: "string",
          title: "Make"
        },
        vehicleModel: {
          type: "string",
          title: "Model"
        },
        vehicleRegistration: {
          type: "string",
          title: "Registration Number"
        },
        vehicleVinNumber: {
          type: "string",
          title: "VIN Number"
        }
      }
    },
    driverOwnerDetails: {
      type: "object",
      title: "Full Details of Driver and Owner",
      required: ["driverIsOwner"],
      properties: {
        driverIsOwner: 
        {

          type: "string",
          title: "Is the driver the owner of the vehicle?",
          enum: ["Yes", "No"]
        
          },      
       driverDetails: 
        {
          type: "object",
          title: "Details of Driver",
          required: ["driverFullName", "driverIdPassport", "driverOccupation", "driverPermissionByInsured", "driverContactNumber"],
          properties: {
            driverFullName: {
              type: "string",
              title: "Full Name"
            },
            driverIdPassport: {
              type: "string",
              title: "ID / passport number"
            },
            driverOccupation: {
              type: "string",
              title: "Occupation"
            },
            driverPermissionByInsured: {
              type: "string",
              title: "Was the driver using the vehicle with the insured's permission"
            },
            driverContactNumber: {
              type: "string",
              title: "Contact Number"
            },
            driverEmail: {
              type: "string",
              format: "email",
              title: "Email"
            }
          }    
    }
  }
},
    witnesses: {
      type: "object",
      title: "Witnesses",
      properties: {
        witnessList: {
          title: "Witnesses",
          type: "array",
          items: {
            type: "object",
            properties: {
              witness: {
                type: "array",
                title: "Witness",
                items: [{
                  key: "name",
                  type: "string",
                  title: "Name"
                }, {
                  key: "string",
                  type: "string",
                  title: "Contact Number"
                }, {
                  key: "address",
                  type: "string",
                  title: "Address"
                }]
              }
            }
          }
        }
      }
    },
    description: {
      type: "object",
      title: "Description",
      properties: {
        descriptionSketch: {
          title: "Sketch of Events Resulting on Loss or Damage",
          type: "array",
          items: {
            type: "object",
            properties: {
              attachment: {
                type: "array",
                title: "Attachment",
                items: [{
                  key: "attachName",
                  title: "Title",
                  type: "string",
                  maxLength: 200
                }, {
                  key: "attachmentContent",
                  type: "array",
                  title: "Attachment",
                  items: {
                    type: "string",
                    format: "data-url"
                  }
                }]
              }
            }
          }
        },
        descriptionText: {
          type: "string",
          title: "Description of Events Resulting in Loss or Damage"
        }
      }
    },
    injured: {
      type: "object",
      title: "Injured Persons",
      properties: {
        personalInjuries: {
          type: "string",
          title: "Where any parties injured in the incident?",
          enum: ["Yes", "No"]
        }
      },
      dependencies: {
        personalInjuries: {
          oneOf: [{
            properties: {
              personalInjuries: {
                enum: ["Yes"]
              },
              personalInjuriesList: {
                title: "Personal Injuries",
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    person: {
                      type: "array",
                      title: "Injured Person",
                      items: [{
                        key: "name",
                        type: "string",
                        title: "Name"
                      }, {
                        key: "string",
                        type: "string",
                        title: "Contact Number"
                      }, {
                        key: "address",
                        type: "string",
                        title: "Address"
                      }, {
                        key: "age",
                        type: "number",
                        title: "Age"
                      }, {
                        key: "relationship",
                        title: "Relationships",
                        description: "If person named above is in your service, your tenant, or related to you, give full details",
                        type: "string"
                      }]
                    }
                  }
                }
              }
            }
          }, {
            properties: {
              personalInjuries: {
                enum: ["No"]
              }
            }
          }]
        }
      }
    },
    thirdParty: {
      type: "object",
      title: "Third Party",
      required: ["thirdPartyName", "thirdPartyContactPerson", "thirdPartyContactNumber", "thirdPartyInsurerDetails", "thirdPartyPolicyNumber"],
      properties: {
        thirdPartyName: {
          type: "string",
          title: "Name"
        },
        thirdPartyContactPerson: {
          type: "string",
          title: "Contact Person"
        },
        thirdPartyContactNumber: {
          type: "string",
          title: "Contact Number"
        },
        thirdPartyEmail: {
          type: "string",
          format: "email",
          title: "Email"
        },
        thirdPartyInsurerDetails: {
          type: "string",
          title: "Insurer Details"
        },
        thirdPartyPolicyNumber: {
          type: "string",
          title: "Policy Number"
        }
      }
    },
    thirdPartyvehicleDetails: {
      type: "object",
      title: "Third Party Vehicle Details",
      required: ["thirdPartyMake", "thirdPartyYear", "thirdPartyModel", "thirdPartyRegistration", "thirdPartyDamageDetails"],
      properties: {
        thirdPartyMake: {
          type: "string",
          title: "Make"
        },
        thirdPartyYear: {
          type: "number",
          title: "Year"
        },
        thirdPartyModel: {
          type: "string",
          title: "Model"
        },
        thirdPartyRegistration: {
          type: "string",
          title: "Registration Number"
        },
        thirdPartyVinNumber: {
          type: "string",
          title: "VIN Number"
        },
        thirdPartyDamageDetails: {
          type: "string",
          title: "Details of damage"
        }
      }
    },
    thirdPartyinjured: {
      type: "object",
      title: "Third Party Injured Persons",
      properties: {
        thirdPartyInjuries: {
          type: "string",
          title: "Where any parties injured in the incident?",
          enum: ["Yes", "No"]
        }
      },
      dependencies: {
        thirdPartyInjuries: {
          type: "object",
          title: "Personal Injuries",
          properties: {
            thirdPartyInjuriesList: {
              title: "Personal Injuries",
              type: "array",
              items: {
                type: "object",
                properties: {
                  person: {
                    type: "array",
                    title: "Injured Person",
                    items: [{
                      key: "name",
                      type: "string",
                      title: "Name"
                    }, {
                      key: "contactNumber",
                      type: "string",
                      title: "Contact Number",
                      minLength: 10
                    }, {
                      key: "contactPerson",
                      type: "string",
                      title: "Contact Person"
                    }, {
                      key: "contactEmail",
                      type: "string",
                      title: "Contact Email"
                    }, {
                      key: "injuriesDescription",
                      type: "string",
                      title: "Description of Injuries"
                    }]
                  }
                }
              }
            }
          }
        }
      }
    },
    attachments: {
      type: "object",
      title: "Attachments",
      properties: {
        attachmentsList: {
          title: "Attachments",
          type: "array",
          items: {
            type: "object",
            properties: {
              attachment: {
                type: "array",
                title: "Attachment",
                items: [{
                  key: "attachName",
                  title: "Title",
                  type: "string",
                  maxLength: 200
                }, {
                  key: "attachmentContent",
                  type: "array",
                  title: "Attachment",
                  items: {
                    type: "string",
                    format: "data-url"
                  }
                }]
              }
            }
          }
        }
      }
    },
    declaration: {
      type: "object",
      title: "Declaration",
      required: ["insuredaccepttc"],
      description: "I/we declare that to the best of my / our knowledge the above statements are true. I acknowledge that the information set out above is provided freely so that Western may process my claim and give effect to the terms and conditions contained in the policy wording. I herewith give my consent that Western may use this information, my personal information on record and additional information obtained from other sources in order to determine whether to accept or reject my claim and take all necessary steps ancillary thereto to give effect hereto. I understand that I may be liable for output VAT in terms of section 8(8) of the VAT Act 89 of 1991.",
      properties: {
        insuredaccepttc: {
          type: "boolean",
          title: "Accept terms and conditions",
          description: "Tick box to accept terms and conditions"
        },
        insuredcapcity: {
          type: "string",
          title: "Capacity"
        },
        insureddate: {
          type: "string",
          title: "Date",
          format: "date"
        }
      }
    }
  }
};

export var uiSchema = {
  damageOrAccident: {
    incidentAddress: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 5
      }
    },
    incidentPolicyDetails: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 5
      }
    },
    descriptionText: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 5
      }
    }
  },
  witnessList: {
    "ui:options": {
      orderable: false
    }
  },
  personalInjuriesList: {
    "ui:options": {
      orderable: false
    }
  },
  thirdPartyInjuriesList: {
    "ui:options": {
      orderable: false
    }
  }
};